import React__default, { useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { S as SvgTick } from './tick-0fcee1f1.js';

var styles = {"progressStepsIndicator":"ProgressStepsIndicator-module_progressStepsIndicator__13PL6","component":"ProgressStepsIndicator-module_component__3HP9-","withLabels":"ProgressStepsIndicator-module_withLabels__3vzR4","stepCircle":"ProgressStepsIndicator-module_stepCircle__37x8y","circleLifted":"ProgressStepsIndicator-module_circleLifted__ZefyM","step":"ProgressStepsIndicator-module_step__1EdAw","stepLabel":"ProgressStepsIndicator-module_stepLabel__18C5r","stepLifted":"ProgressStepsIndicator-module_stepLifted__3eQVK"};

const ProgressStepsIndicator = ({
  className,
  index = 0,
  onStepClick = () => {},
  showLabels = true,
  steps = []
}) => {
  useEffect(() => {
    /**
     * This side effect dynamically add progress steps css rules
     * It use low-level JS CSSStyleSheet API to be super efficient
     * The reason to do it is to calculate correct progress steps values
     *
     * @ref https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleSheet#Browser_compatibility
     */
    const step = 100 / (steps.length - 1);
    const styleSheetAttribute = 'data-motorway-stylesheet';
    const styleSheetAttributeValue = `ProgressStepsIndicator_${steps.length}`;
    const attachedStyleElement = document.querySelector(`[${styleSheetAttribute}]`);
    const styleElement = attachedStyleElement || document.createElement('style');
    if (!attachedStyleElement) {
      styleElement.setAttribute(styleSheetAttribute, styleSheetAttributeValue);
      document.head.appendChild(styleElement);
    }
    const styleSheet = styleElement.sheet;
    for (let i = 0; i < steps.length; i += 1) {
      styleSheet.insertRule(`.${styles.component}[data-index="${i}"]::after { width: ${step * i}%; }`, styleSheet.cssRules.length);
    }
    return () => {
      document.head.removeChild(styleElement);
    };
  }, [steps]);
  const containerClassName = cx(styles.component, className, {
    [styles.withLabels]: showLabels
  });
  const onClick = i => e => onStepClick(e, i);
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.progressStepsIndicator,
    "data-motorway-id": "ProgressStepsIndicator"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: containerClassName,
    "data-index": index
  }, steps.map((entry, i) => {
    const stepNumber = i + 1;
    const lifted = i === index || entry.completed;
    const classes = {
      label: styles.stepLabel,
      step: cx(styles.step, {
        [styles.stepLifted]: lifted
      }),
      stepCircle: cx(styles.stepCircle, {
        [styles.circleLifted]: lifted
      })
    };
    return /*#__PURE__*/React__default.createElement("div", {
      key: entry.id,
      className: classes.step
    }, showLabels ? /*#__PURE__*/React__default.createElement("span", {
      className: classes.label,
      "data-testid": "step-label"
    }, entry.name) : null, /*#__PURE__*/React__default.createElement("button", {
      className: classes.stepCircle,
      "data-testid": "step",
      onClick: onClick(i),
      type: "button"
    }, entry.completed ? /*#__PURE__*/React__default.createElement(SvgTick, {
      "data-testid": "step-completed",
      height: "24",
      width: "24"
    }) : stepNumber));
  })));
};
ProgressStepsIndicator.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  index: PropTypes.number,
  onStepClick: PropTypes.func,
  showLabels: PropTypes.bool,
  steps: PropTypes.arrayOf(PropTypes.shape({
    completed: PropTypes.bool,
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    visited: PropTypes.bool
  }))
};

export { ProgressStepsIndicator as default };
